import styled from "styled-components";

interface CodeProps {
  bg?: string;
  color?: string;
}

export const Code = styled.div<CodeProps>`
  background-color: ${props => props.bg || '#ffffff'};
  color: ${props => props.color || '#e31a37'};
  border-radius: 0.2rem;
  padding: 2px 10px;
  font-size: 17px;
  letter-spacing: 4px;
  text-align: center;
  font-family: 'Maison Neue', sans-serif;
  width: 100%;
`;

export default Code;